export default {
  namespaced: true,
  commands: {
    title: "Comando personalizado",
    title_main: "Comando personalizado",
    action_add: 'Criar comando personalizado',
    action_update: 'Atualizar comando personalizado',
    base_commands: 'Comandos básicos',
    custom_commands: 'Comandos personalizados',
    fields: {
      name: {
        label: 'Nome do comando',
        placeholder: 'Nome do comando'
      },
      description: {
        label: 'Descrição do comando',
        placeholder: 'Descrição do comando'
      },
      alarm_compatible: {
        label: "É compatível com alarmes?"
      },
      requirements: {
        label: 'Requisitos (opcional)'
      }
    },
    messages: {
      success_created: 'Comando personalizado criado com sucesso',
      success_updated: 'Comando personalizado atualizado com sucesso',
      layout_empty: 'Não é possível salvar um comando vazio',
      connections_empty: 'Não são permitidos nós sem conexões',
      connections_qty_exceeded: 'Não são permitidos nós com múltiplas conexões',
      incomplete_node_config: 'Configuração incompleta nos seguintes nós',
      alarm_category_requires_alarm_compatibility: 'Este comando é compatível apenas com alarmes. Ative “É compatível com alarmes?” para usá-lo.',
    },
    btns: {
      delete_image: 'Excluir imagem',
      create: 'Salvar',
      update: 'Atualizar',
      custom: 'Personalizado',
      base: 'Padrão',
    },
    requirements: {
      cols: {
        col1: 'Tipo',
        col2: 'Config.',
        col3: 'Seleção Múltip.'
      }
    },
    list: {
      enable_unit_cameras_do: {
        name: "Ativar saída digital das câmeras",
        desc: "Ativa a saída digital das câmeras da instalação",
      },
      enable_speaker: {
        name: "Ativar DO1 do roteador",
        desc: "Ativa a saída digital do roteador"
      },
      show_user_view: {
        name: "Mostrar visualização/tab",
        desc: "Muestra uma visualização/tab en SBO"
      },
      delay: {
        name: "Atraso",
        desc: "",
        hint: "Quantidade de tempo em segundos:"
      },
      active_digital_output_camera: {
        name: "Ativa saída digital das câmeras (antigas)",
        desc: "Ativar saída digital das câmeras",
        hint: "",
      },
      activate_digital_output_camera: {
        name: "Ativa saída digital das câmeras",
        desc: "Ativar saída digital das câmeras",
        hint: "",
      },
      deactivate_digital_output_camera: {
        name: "Desativar saída digital das câmeras",
        desc: "Desativa a saída digital das câmeras",
        hint: "",
      },
      deactive_sound_router: {
        name: "Desativa DO1 do roteador",
        desc: "Desativar a saída digital do roteador",
        hint: "",
      },
      push_camera_monitor: {
        name: "Coloque a câmera no monitor",
        desc: "Coloca a câmera selecionada na visualização do monitor",
        hint: "",
      },
      interphone_call: {
        name: "Chamada de intercomunicador",
        desc: "Faz uma chamada de intercomunicador"
      },
      active_digital_output_rtu_router: {
        name: "Ativar saída digital RTU roteador",
        desc: "Ativa uma saída digital específica do roteador",
        hint: "",
      },
      activate_additional_router_digital_output: {
        name: 'Ativar saída digital do roteador adicional',
        desc: 'Ativa uma saída digital no roteador adicional selecionado',
      },
      density_shoot: {
        name: "Realize um tiro real de neblina",
        desc: "Execute um disparo real de névoa do dispositivo especificado",
      },
      density_test_shoot: {
        name: "Realizar disparo de prueba de niebla",
        desc: "Realize um disparo de teste de névoa do dispositivo especificado",
      },
      notification_command: {
        name: "Enviar notificação",
        desc: "Envie notificações de diferentes formas como Mensagem de Texto, E-mail, Webhook, Whatsapps...",
      },
      show_action_plan: {
        name: "Mostrar um plano de ação",
        desc: "Mostra o plano de ação especificado",
      },
      camera_round: {
        name: "Rotação de câmeras",
        desc: "Comando para iniciar uma rotação de câmeras",
      },
      assignment_cameras: {
        name: "Atribuição de câmera",
        desc: "Atribuição de câmera",
      },
      alarm_panel_activate_output: {
        name: "Central de alarmes - Ativar saída",
        desc: "Central de alarmes - Ativar saída",
      },
      alarm_panel_deactivate_output: {
        name: "Central de alarmes - Desativar saída",
        desc: "Central de alarmes - Desativar saída",
      },
      activate_device_output: {
        name: "Ativar saída de dispositivo",
        desc: "Ativar saída de dispositivo",
      },
      deactivate_device_output: {
        name: "Desativar saída de dispositivo",
        desc: "Desativar saída de dispositivo",
      },
      activate_camera_ptz_preset: {
        name: "Ativar o pré-ajuste PTZ de uma câmera",
        desc: "Ativar o pré-ajuste PTZ de uma câmera",
      },
      activate_generic_device_digital_output: {
        name: "Ativar saída digital do dispositivo genérico",
        desc: "Ativar saída digital do dispositivo genérico",
      },
      deactivate_generic_device_digital_output: {
        name: "Desativar saída digital do dispositivo genérico",
        desc: "Desativar saída digital do dispositivo genérico",
      },
      assign_action_plan: {
        name: "Atribuir tarefa aos usuários",
        desc: "Atribuir tarefa aos usuários",
      },
      assign_operational_form_task: {
        name: "Atribuir tarefa com formulário operacional",
        desc: "Atribui a um usuário uma tarefa para preencher um formulário de segurança operacional",
      },
      notify_panel_failure: {
        name: "Falha do painel",
        desc: "Notifica a falha do dispositivo aos usuários com a permissão de notificações de falha de alarme",
      },
      response_operational_form: {
        name: "Criar resposta de formulário operacional",
        desc: "Cria uma resposta de formulário de segurança operacional a partir de um modelo",
      },
      "response-operational-form": {
        name: "Criar resposta de formulário operacional",
        desc: "Cria uma resposta de formulário de segurança operacional a partir de um modelo",
      },
      dispatch_alarm: {
        name: "Disparar alarme",
        desc: "Disparar alarme",
      },
      create_helpdesk_ticket: {
        name: "Criar tíquete de helpdesk",
        desc: "Criar tíquete de helpdesk",
      },
      alarm_image_inference: {
        name: "Inferindo contexto de uma imagem",
        desc: "Inferindo contexto de uma imagem",
      },
      update_alarm_level_command: {
        name: "Atualizar nível de alarme",
        desc: "Atualiza o nível de um alarme",
      },
      update_alarm_status_command: {
        name: "Atualizar o status de um alarme",
        desc: "Atualizar o status de um alarme",
      },
      restore_alarm_command: {
        name: "Restabelecer cor do alarme",
        desc: "Restabelece a cor do indicador do alarme para verde",
      },
      update_alarm_type_command: {
        name: "Atualizar o tipo de um alarme",
        desc: "Atualizar o tipous de um alarme",
      },
      update_alarm_category_command: {
        name: "Categoria de alarme",
        desc: "Atualiza o protocolo de um alarme com uma mensagem do catálogo",
      },
      ai_decision: {
        name: "AI Decision",
        desc: "AI Decision",
        decision: "Resposta",
      },
      deactive_digital_output_rtu_router: {
        name: "Deativar saída digital RTU roteador",
        desc: "Desativa uma saída digital específica do roteador",
        hint: "",
      },
      action_excecute_dmp_panel: {
        name: "Executar ação no painel DMP",
        desc: "Executar ação no painel DMP",
      },
      action_execute_intelbras_panel: {
        name: "Executar ação no painel INTELBRAS",
        desc: "Executar ação no painel INTELBRAS",
      },
      action_execute_pacom_panel: {
        name: "Executar ação no painel PACOM",
        desc: "Executar ação no painel PACOM",
      },
      assign_alarm_user: {
        name: 'Atribuir alarme ao usuário',
        desc: 'Atribuir alarme ao usuário'
      },
      activate_digital_output_hikvision_camera: {
        name: "Ativar saída digital de uma câmera Hikvision",
        desc: "Ativar saída digital de uma câmera Hikvision",
      },
      action_execute_panel_from_alarm: {
        name: "Executar ação no painel a partir da alarma",
        desc: "Executar ação no painel a partir da alarma",
      },
      send_external_cad_emergency_test: {
        name: 'Enviar prueba de emergencia CAD externa'
      },
      batch_alarm_attention: {
        name: 'Resposta de alarme em lote',
        desc: 'Resposta de alarme em lote'
      },
    },
    form: {
      units_select: {
        label: 'Selecione as instalações para este nó:'
      },
      additional_router: {
        label: 'Selecione o roteador para este nó:',
        hint: 'Selecione uma instalação primeiro.',
      },
      digital_output: {
        label: 'Selecione a saída digital para este nó:',
      },
      cameras_select: {
        label: 'Selecciona las cámaras para este nodo:'
      },
      user_views_select: {
        label: 'Selecione as câmeras para este nó:'
      },
      users_select: {
        label: 'Selecione os usuários para este nó:'
      },
      profiles_select: {
        label: 'Selecione os perfis de destino:',
        hint: 'Os perfis de destino devem ter a permissão "Receber notificações do comando Notificação".',
      },
      interphone_from: {
        label: 'Selecione o telefone de origem:'
      },
      interphone_to: {
        label: 'Selecione o telefone de destino:'
      },
      density_device: {
        label: 'Selecione o dispositivo Density:'
      },
      type_notificaction: {
        label: 'Tipo de notificação:'
      },
      type_verb_webhook: {
        label: 'Verbo RESTful:'
      },
      url1: {
        label: 'Insira o URL do alarme',
      },
      url2: {
        label: 'Insira o URL dos feedbacks do alarme',
      },
      action_plan: {
        label: 'Selecione um plano de ação:'
      },
      operational_form_template_select: {
        label: 'Selecione o modelo do formulário operacional:'
      },
      alarm_select: {
        label: 'Vincular um alarme (opcional):'
      },
      comment: {
        label: 'Comentário (opcional)'
      },
      comment_field: {
        label: 'Comentário (opcional)'
      },
      layouts: {
        label: 'Selecione um layout:'
      },
      loop: {
        label: 'Ciclo:'
      },
      location: {
        label: 'Insira a localização:',
        fields: {
          lat: 'Latitude',
          lng: 'Longitude',
          from_alarm: 'Pegar valor do alarme'
        }
      },
      radius: {
        label: 'Insira o raio:'
      },
      delay: {
        label: 'Insira o atraso',
      },
      message_template: {
        label: 'Modelo de mensagem',
        characters_remaining: 'Personagens restantes',
        available_placeholders: 'Espaços reservados disponíveis',
        insert_placeholder: 'Inserir placeholder',
        placeholder_hint: 'Digite @ para buscar e inserir um placeholder.',
        search_placeholder: 'Buscar placeholder…',
        no_placeholders_found: 'Nenhum placeholder encontrado.',
        categories: {
          alarm: 'Alarmes',
          location: 'Localização',
          camera: 'Câmera',
          media: 'Multimídia',
          other: 'Outros',
        },
        placeholders: {
          alarm_image: 'URL da imagem quando o alarme vem de um evento de análise de vídeo',
          alarm_image_url: 'URL da imagem quando o alarme vem de um evento de análise de vídeo',
          municipality: 'Município da instalação',
          region: 'Região da instalação',
          facility_format: 'Texto anterior ao primeiro "_" da descrição da instalação (MBA em MBA_3030)',
          facility_determinant: 'Texto posterior ao primeiro "_" da descrição da instalação (3030 em MBA_3030)',
          camera_name: 'Nome da câmera associada ao alarme',
          facility_comment: 'Comentários da instalação',
        },
        help: {
          header: 'Escreva o texto que será enviado pelo WhatsApp. Você pode usar os seguintes espaços reservados que serão posteriormente substituídos pelas informações do alarme:',
          footer: {
            title: 'Exemplo',
            body: 'Comando executado do instalação @facility_name, id do alarme #@id_alarm do tipo @alarm_type'
          }
        }
      },
      subject: {
        label: 'Assunto',
      },
      groups_select: {
        label: 'Selecione os grupos para este nó:'
      },
      tenants_select: {
        label: 'Selecione os tenants para este nó:'
      },
      centers_select: {
        label: 'Selecione os centers para este nó:'
      },
      sectors_select: {
        label: 'Selecione os sectors para este nó:'
      },
      filter_field: {
        label: 'Adicionar filtro para este nó:'
      },
      email: {
        label: 'Insira os e-mails',
      },
      phone: {
        label: 'Insira os telefones',
      },
      receiver: {
        label: 'Insira o receptor',
      },
      authorization: {
        label: 'Insira sua chave de autorização',
      },
      json_editor: {
        apply: 'Aplicar',
        cancel: 'Cancelar',
        expand: 'Abrir editor JSON',
        format: 'Formatar JSON',
        invalid: 'JSON inválido',
        title: 'Editor de modelo JSON',
        valid: 'JSON válido',
      },
      alarm_panels: {
        label: 'Selecione a central de alarme'
      },
      alarm_panel_devices: {
        label: 'Selecione um dispositivo da central de alarme',
        hint: 'Observação: quando o valor for obtido de um alarme, "Input" e "Zone" serão a mesma coisa.'
      },
      cmd_config: {
        label: 'Configuração de comando',
        hint: 'Selecione o comando e defina suas configurações abaixo.'
      },
      camera_ptz_presets: {
        label: 'Predefinições de câmera PTZ',
        hint: 'Digite ou selecione uma predefinição de PTZ para a câmera'
      },
      device_tags: {
        label: 'Etiquetas do dispositivo',
        hint: 'Digite ou selecione uma tag de dispositivo'
      },
      device_proxy_id: {
        label: 'Dispositivo',
        hint: 'Selecione um dispositivo'
      },
      alarm_types: {
        label: 'Selecione um tipo de alarme',
        hint: 'Selecione um tipo de alarme'
      },
      helpdesk_users_from: {
        label: 'Selecione um usuário',
        hint: 'Selecione o usuário que criará o ticket'
      },
      helpdesk_users_to: {
        label: 'Selecione os usuários',
        hint: 'Selecione os usuários que devem receber uma cópia do e-mail'
      },
      helpdesk_groups: {
        label: 'Grupos',
        hint: 'Selecione os grupos associados ao ticket'
      },
      prompt: {
        label: 'Insira um prompt',
      },
      alarm_levels: {
        label: 'Selecione um nível de alarme',
      },
      alarm_status: {
        label: 'Selecione um status de alarme',
      },
      message: {
        label: 'Digite a mensagem',
      },
      group_name: {
        label: 'Nome do grupo',
        hint: 'Digite o nome do grupo.'
      },
      cat_base_url: {
        label: 'Url'
      },
      cat_user_id: {
        label: 'Id de usuario'
      },
      cat_timeout: {
        label: 'Tiempo de espera'
      },
      sectors: {
        label: 'Selecione um sector',
        hint: 'Select a sector.'
      },
    },
    data_types: {
      users: 'Usuários',
      profiles: 'Perfis',
      user_views: 'Visualizações do usuário',
      units: 'Instalações',
      cameras: 'Câmeras',
      phone: 'Telefones',
      email: 'E-mails',
      log_id: 'Registros',
      do: 'Saída digital',
      additional_router: 'Roteador adicional',
      interphone_from: 'Chamada interfon (de)',
      interphone_to: 'Chamada interfon (a)',
      message_template: 'Mensagem',
      subject: 'Assunto',
      type: 'Tipo de notificação',
      receiver: 'Receptor',
      verb: 'Verbo RESTful',
      authorization: 'Autorização',
      url1: 'URL de alarme',
      url2: 'URL de feedback de alarme',
      webhook: 'URL Webhook',
      action_plan: 'Plano de ação',
      operational_form_template: 'Modelo de formulário operacional',
      alarm: 'Alarme',
      alarm_category_message: 'Mensagem de categoria de alarme',
      comment: 'Comentário',
      delay: 'Atraso',
      layout: 'Layouts',
      location: 'Localização',
      radius: 'Radio',
      loop: 'Ciclo',
      density_device: 'Dispositivo Density',
      groups: 'Grupos',
      tenants: 'Tenants',
      centers: 'Centers',
      sectors: 'Sectors',
      filter: 'Filtros',
      alarm_panels: 'Centrais de alarme',
      alarm_panel_devices: 'Dispositivos de central de alarme',
      cmd_config: 'Configuração de comando',
      camera_ptz_presets: 'Predefinições de câmera PTZ',
      device_tags: 'Etiquetas do dispositivo',
      device_proxy_id: 'Dispositivo',
      alarm_types: 'Tipos de alarme',
      helpdesk_groups: 'Grupos de helpdesk',
      helpdesk_users_from: 'Usuário',
      helpdesk_users_to: 'Usuários',
      commands:{
        form: {
          cameras_select: {
            label: 'Seleccionar cámaras'
          }
        }
      }
    },
    flowchart: {
      show_hide_node_config: 'Mostrar/ocultar configurações de comando',
    },
    gridWidget: {
      title: 'Comandos',
      table: {
        no_data: "Nenhuma informação disponível",
        rows: {
          1: "Nome",
          2: "Descrição",
        }
      }
    },
    cameras: {
      label: 'Cámaras'
    },
    modal: {
      title: 'Execução de comando',
      body: 'O seguinte comando será executado',
      btns: {
        continue: 'Prosseguir',
        cancel: 'Cancelar'
      },
      messages: {
        success: 'Status: Comando executado com sucesso',
        error: 'Estado: Ocorreu um erro'
      }
    },
    config_modal: {
      title: 'Configuração de comando',
      messages: {
        invalid_form: 'Por favor, corrija os erros no formulário',
      },
      chart: {
        label: 'Gráfico incorporado',
        hint: 'Exibe um gráfico dentro do nó (dados de demonstração).',
        types: {
          none: 'Nenhum',
          bar: 'Barras',
          line: 'Linhas',
          pie: 'Circular',
          graph: 'Grafo (força)',
        }
      }
    },
    logs: {
      title: 'Log de comandos',
      filters: {
        commands: 'Comandos'
      },
      table: {
        id_operation: 'ID da operação',
        user: 'Usuário',
        description: 'Descrição',
        command: 'Comando',
        command_source: 'Comando relacionado',
        level: 'Nivel',
        data: 'Informação',
        date: 'Data'
      }
    },
    units: {
      seconds: 'segundo(s)',
      meters: 'metro(s)',
    },
    panels: {
      user_panel: 'Panel',
      device_panel: 'Device',
      action_panel: 'Ação'
    },
    device_action_panel: {
      title: 'Ação do dispositivo',
      action: 'Ação',
      actions: {
        RESTORE: 'Restaurar',
        RESET: 'Redefinir',
        BYPASS: 'Bypass',
        ARM: 'Armar',
        DISARM: 'Desarmar',
      },
    }
  }
}
